import React from 'react'

import './link-externo.scss'
import _ from 'lodash'

const getUrl = (props) => {
  const url = _.get(props, 'location.state.url', '')
  if (url) {
    const newUrl = url.replace('/geral/linkExterno/', '')
    if (newUrl.endsWith('/')) {
      return newUrl.substring(0, newUrl.length - 1)
    }
    return newUrl
  }
  return url
}

export const LinkExternoForm = (props) => {
  return (
    <div className="container">
      <iframe className="responsive-iframe" src={getUrl(props)}></iframe>
    </div>
  )
}
